import {PsychometricParameterTypeShort} from "../gen/api";
import {psychometricApi} from "../api/api";

class PsychometricService {
  getPsychometricParameters(): Promise<PsychometricParameterTypeShort[]> {
    return psychometricApi.getPsychometricParameterTypes()
    .then(response => {
      if (response.status === 200) return response.data;
      else throw new Error("Rest call failed with code " + response.status)
    });
  }
}

export default new PsychometricService();
